module.exports = __webpack_public_path__ + "img/user-group-me_ar.9fb53ca6.png";